module.exports = __webpack_public_path__ + "static/Mambu_homepage_January2019-abcb61062599e6525be26924f38fe75f.jpg";